import { render } from "./ManualPage.vue?vue&type=template&id=0ead06a5&scoped=true"
import script from "./ManualPage.vue?vue&type=script&lang=js"
export * from "./ManualPage.vue?vue&type=script&lang=js"

import "./ManualPage.vue?vue&type=style&index=0&id=0ead06a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ead06a5"]])

export default __exports__